export const ENTITY_PATH = 'payments/payment_page/v1';

export enum PAYMENT_STATUS {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    NEED_CHECK = 'NEED_CHECK',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
    EXPIRED = 'EXPIRED'
}

export enum RESPONSE_ERROR {
    NOT_UNIQUE_CLIENT_FIELDS_VALUES = 'NOT_UNIQUE_CLIENT_FIELDS_VALUES',
}
